import { getAPI , postAPI } from '../../../../api/apis'
import { REACT_APP_CANDIDATE_FREELANCER } from '../../../../utils/common'

export async function getAssessmentRequestHistory(loginId: string | null){
    const Details = getAPI( REACT_APP_CANDIDATE_FREELANCER + `/assessment-request-history/${loginId}?userloginId=`)
    return Details
}

export async function saveAssessmentRequestDetails(data: any){
    const Details = postAPI( REACT_APP_CANDIDATE_FREELANCER + `/assessment-request-details`,data)
    return Details
}

export async function sendRatingReminder(body: any) {
    const Details = postAPI(REACT_APP_CANDIDATE_FREELANCER + '/api/resendAssessmentRequest', body)
    return Details
}